import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { AntdRadioButton, Filters, RadioOptions } from "./styles";
import { Space, Radio } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Main from "../../../../layout/main/Main";
import { COLORS, Typo } from "../../../../layout/theme";
import DataTable from "../../../../common/data-table/DataTable";
import { useAuth } from "../../../../../contexts/authContext";
import {
	get_agent_clients_header_info,
	get_agent_clients_page,
} from "../../../../../api/endpoints/agents";

export default function LaboratoryAgentConversationList({ clientId }) {
	const navigate = useNavigate();
	const { userdata } = useAuth();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [data, setData] = useState(null);
	const [state, setState] = useState("ACTIVE");
	const [headerInfo, setHeaderInfo] = useState(null);
	const [key, setKey] = useState("null");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>Laboratorio</div>,
			dataIndex: "name",
			width: 300,
			render: (value, record) => (
				<Link
					to={`/admin/laboratoryAgentConversations/${key.id}?uri=${uri}`}
					onMouseOver={() => setKey(record)}
				>
					<Typo type="secondary" fontWeight={600} fontSize={14}>
						{value}
					</Typo>
				</Link>
			),
		},
	];

	const fetch_data_agent_clients = async (page, search) => {
		const res = await get_agent_clients_page(search, state, page);
		setData(res);
	};

	useEffect(() => {
		fetch_data_agent_clients(1, clientId);
	}, [state]);

	const fetch_agent_clients_header = async (search) => {
		const res = await get_agent_clients_header_info(search);
		setHeaderInfo(res);
	};

	useEffect(() => {
		fetch_agent_clients_header(clientId);
	}, [state]);

	return (
		<Main>
			<Main.Breadcrumb>
				<Main.BreadcrumbItem>
					{uri ? (
						<Link to={"/" + uri}>Configuración General</Link>
					) : (
						<Link to="/">Home</Link>
					)}
				</Main.BreadcrumbItem>
				<Main.BreadcrumbSeparator />
				<Main.ActiveBreadcrumbItem>
					Listado de clientes
				</Main.ActiveBreadcrumbItem>
			</Main.Breadcrumb>

			<Main.Body>
				<Filters></Filters>
				<RadioOptions>
					<Radio.Group value={state} onChange={(e) => setState(e.target.value)}>
						<AntdRadioButton value="ACTIVE">
							Activo ({headerInfo?.totalActive})
						</AntdRadioButton>
						<AntdRadioButton value="DELETED">
							Inactivo ({headerInfo?.totalDisabled})
						</AntdRadioButton>
					</Radio.Group>
				</RadioOptions>
				<DataTable
					data={data}
					fetch={fetch_data_agent_clients}
					columns={columns}
				/>
			</Main.Body>
		</Main>
	);
}
